// import { toast } from "react-toastify";

// export const ToastService = {

//     // toast message on success
//     success: (message) => {
//         toast.success(message)
//     },

//     // toast message if any error
//     error: (message) => {
//         toast.error(message)
//     },

//     // toast message if any warning
//     warning: (message) => {
//         toast.warning(message)
//     },

//     // toast message if any Information
//     info: (message) => {
//         toast.info(message)
//     },

// }


import { getToasterHandler } from '../../contexts/index.jsx';

const DEFAULT_OPTIONS = {
    duration: 5000,
};

const showToast = (type, options) => {
    const addToast = getToasterHandler();

    if (!addToast) {
        console.warn('ToasterProvider is not mounted');
        return;
    }

    addToast({
        type,
        ...DEFAULT_OPTIONS,
        ...options,
    });
};

export const ToastService = {
    success: (options) => showToast('success', options),
    error: (options) => showToast('error', options),
    warning: (options) => showToast('warning', options),
    info: (options) => showToast('info', options),
};